// src/i18n/en.ts
import type { Translations } from "./index";

export const en: Translations = {
  nav: {
    services: "Services",
    reviews: "Reviews",
    contact: "Contact",
  },
  hero: {
    title: "Fast and safe moves in Barcelona",
    subtitle:
      "24/7 moving service in Barcelona and across Catalonia, with a professional team, secure packing and careful handling in every move. Get your instant quote on WhatsApp with no complications.",
    callNow: "Call now",
    whatsapp: "WhatsApp",
  },
  quickQuote: {
    title: "Quick quote",
    name: "Your name",
    from: "Pickup address",
    to: "Delivery address",
    date: "Date",
    sendWhatsApp: "Send via WhatsApp",
    helper: "Fill the fields and we'll open WhatsApp with a pre-filled message.",
  },
  services: {
    title: "Services",
  },
  reviews: {
    title: "Customer reviews",
    subtitle: "Average rating 4.9 ★ on Google",
  },
  pricing: {
    title: "Sample pricing",
    note: "*Prices without VAT. Parking and tolls not included.",
  },
  contact: {
    title: "Contact",
    subtitle: "Request a quote by phone, WhatsApp or email. We answer in minutes.",
    phone: "Phone:",
    whatsapp: "WhatsApp:",
    email: "Email:",
    sendMediaTitle: "Send us photos or video",
    sendMediaText:
      "The more info we get, the better the quote. We can also do a video call visit.",
    openWhatsApp: "Open WhatsApp",
  },
};